import axios from "axios";
import * as d3 from "d3";
import {axisTextDim4, colonAnnotation, numberFormat, responsivefy} from '../functions'

export default function (chart,divId,vizName, filterParam){


// set the dimensions and margins of the graph
    var margin = chart.margin ,
        width = chart.width - margin.left - margin.right + 500,
        height = chart.height - margin.top - margin.bottom*2 + 300;

    var svg = d3.select(divId)
    svg.selectAll("*").remove();

// append the svg object to the body of the page
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height + chart.margin.top + chart.margin.bottom *2)
        .call(responsivefy)
        .append("g")
        .attr("transform",
            "translate(" + margin.left + "," + margin.top + ")");

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    axios.post(url, filterParam).then(res => {

        let data = res.data;


        var result = data.reduce((x, y) => {

            (x[y.dim1_name] = x[y.dim1_name] || []).push(y);

            return x;

        }, {});


        console.log("dim1_name cate", result, result['triticum'])

        var wide = d3.nest()
            .key(function (d) {
                return d["dim1_name"]
            }) // sort by key
            .rollup(function (d) { // do this to each grouping
                // reduce takes a list and returns one value
                // in this case, the list is all the grouped elements
                // and the final value is an object with keys
                return d.reduce(function (prev, curr) {
                    prev["dim1_name"] = curr["dim1_name"];
                    prev[curr["dim2_name"]] = curr["metric1"];
                    console.log("prev", prev)
                    return prev;
                }, {});
            })
            .entries(data) // tell it what data to process
            .map(function (d) { // pull out only the values
                console.log("wides", d)//amit garg,andrews etc...
                return d.value;
            });

        // List of subgroups = header of the csv files = soil condition here
        var subgroups = [...new Set(data.map(obj => obj.dim2_name))]

        // List of groups = species here = value of the first column called dim1_name -> I show them on the X axis
        // var groups = d3.map(data, function(d){return(d.dim1_name)}).keys()
        var groups = [...new Set(data.map(obj => obj.dim1_name))]
        var lineData = []

        groups.forEach(g => {
            let sum=0;
            result[g].forEach(r=>{
                sum += r["metric1"]
                // console.log("loop r ",r,sum)
                result[g][0]['total']=sum
            })
            lineData.push(result[g][0])
        })

        console.log("Data", data, subgroups, groups, wide, lineData)
        // Add X axis
        var x = d3.scaleBand()
            .domain(groups)
            .range([0, width])
            .padding([0.2])
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom().scale(x).tickSizeOuter(0))
            .style('font-size', "20px")
            .selectAll('text')
            .style('text-anchor', 'end')
            // .attr('dx', XaxisAttribute)
            .attr("dx", "-.8em")
            .attr("dy", ".15em")
            .attr('transform', 'rotate(-50)')
           // .style('font-weight', 'bold') //effect in y-axis label
            .style("font-family", "Times New Roman ")
            .text(axisTextDim4);

        // Add Y axis
        var y = d3.scaleLinear()
            .domain([0, d3.max(lineData, function (d) {
                return +d.total;
            })])
            .range([height, 0]);
        svg.append("g")
            .call(d3.axisLeft(y).tickFormat(numberFormat))
            .style('font-size', "20px")
            .style('font-weight', 'bold') //effect in y-axis label
            .style("font-family", "Times New Roman ")
        ;





        var color = d3.scaleOrdinal()
            .domain(subgroups)
            // .range(["#D1EEEE", "#9ecae1", "#6baed6",'#7ca6e7', "#4292c6",'#345bd7', "#2171b5", "#08519c", "#08306b"])
            .range(['#e9beb4','red','green','orange','blue','olive','yellow','grey','brown'])
        // .range(['#0033CC', '#345bd7', '#4986e7', '#7ca6e7'])

//stack the data? --> stack per dim2_name
        var stackedGen = d3.stack()
            .keys(subgroups)
        var stackedData = stackedGen(wide)
        console.log("StackedData", stackedData)
        d3.select("tooltip"+divId.id).remove(); // clear tooltip based on class of tip element
        var div= d3.select(divId).append('div').attr('class', 'tooltip').attr('style', 'position: absolute; opacity: 0;');


        // Show the bars
        svg.append("g")
            .selectAll("g")
            // Enter in the stack data = loop key per key = dim1_name per dim1_name
            .data(stackedData)
            .enter().append("g")
            .attr("fill", function (d) {
                return color(d.key);
            })
            .selectAll("rect")
            // enter a second time = loop subgroup per subgroup to add all rectangles
            .data(function (d) {
                return d;
            })
            .enter().append("rect")
            .attr("x", function (d) {
                return x(d.data.dim1_name);
            })
            .attr("y", function (d) {
                return y(d[1]);
            })
            .attr("height", function (d) {
                return y(d[0]) - y(d[1]);
            })
            .attr("width", x.bandwidth())
            .attr("stroke", "grey")
            .on("mousemove", function (d) {
                var subgroupName = d3.select(this.parentNode).datum().key;
                var subgroupValue = numberFormat(d.data[subgroupName]);
                let pctMetric3 = numberFormat(data.filter(f=>f.dim1_name==d.data.dim1_name && f.dim2_name==subgroupName).map(f=>f.metric3)[0])
                console.log("tooltip data",d,data.filter(f=>f.dim1_name==d.data.dim1_name).map(f=>f.metric3)[0])

                div.html(chart.x1AxisDisplayName + colonAnnotation + d.data.dim1_name
                    + "<br>" +"Product: " + chart.x2AxisDisplayName + colonAnnotation + subgroupName
                    + "<br>" + "Value: " + subgroupValue +" ("+ pctMetric3 +"%)")
                    .style("opacity", 1)
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px")
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });



        // //Add value top of the bar
        // svg.selectAll('text.bartotal')
        //     .data(lineData)
        //     .enter()
        //     .append('text')
        //     .attr('class', 'bar')
        //     .attr('text-anchor', 'middle')
        //     .attr('x', (d)=> { return x(d.dim1_name) + x.bandwidth() / 2 })
        //     .attr('y', (d)=> {return y(d.total)-5 })
        //     .text((d)=> {  return numberFormat(d.total) })
        //     .attr('fill', 'black')
        //     .style('font-size',15)

        // Axis Titles
        svg.append('text')
            .attr('x', (width / 3))
            .attr('y', height + 160)
            //.style('fill', 'blue')
            .style('fill', 'Black')
            .style('font-size', '40px')
            .text(chart.x1AxisDisplayName)
        // .text('dim1_name')

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - 130)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', 'black')
            .style('font-size', '40px')
            .text(chart.y1AxisDisplayName)
        // .text('VAlue')





        var legend = svg.selectAll(".legend")
            // .data(color.domain())
            .data(color.domain().slice().reverse())
            .enter()
            .append("g")
            .attr("class", "legend")
            .attr("transform", function (d, i) {
                const left=margin.right-100;

                return "translate("+left+"," + i * 20 + ")";
            });

        legend.append("rect")
            .attr("x", chart.width - 80)
            .attr("width", 15)
            .attr("height", 15)
            .style("fill", color);

        legend.append("text")
            .attr("x", chart.width - 50)
            .attr("y", 9)
            .attr("dy", ".3em")
            .attr("class", "legend")
            .text(function (d) {
                return d
            });

        // Add dynamic chart title
        svg.append("text")
            .attr("x", width / 2)
            .attr("y", 0 - (margin.top / 2)+20)
            .attr("text-anchor", "middle")
            .style("font-size", "30px")
            .text(chart.title);

    })
}